import { render, staticRenderFns } from "./resources-dictionary-row.vue?vue&type=template&id=332a4a46&scoped=true"
import script from "./resources-dictionary-row.vue?vue&type=script&lang=js"
export * from "./resources-dictionary-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a4a46",
  null
  
)

export default component.exports